import imagePlaceholder from '@/assets/placeholder.png';
import Item from '@/models/Item';
import { MediaType } from '@/models/MediaType';
import { ApplicationState } from '@/store';
import React from 'react';
import { useSelector } from 'react-redux';
import './style.scss';

interface ItemCardProps {
    item: Item;
    add?: boolean;
    handleAddToList: (item: Item) => void;
    handleRemoveFromList: (item: Item) => void;
    error?: boolean;
    showButton?: boolean;
}

const ItemCard = ({ item, add, handleAddToList, handleRemoveFromList, error, showButton }: ItemCardProps) => {
    const { data: strings } = useSelector((state: ApplicationState) => state.locale);

    const renderTitle = (type: MediaType) => {
        switch (type) {
            case 'HTML':
                return strings.ARTICLE;
            case 'AUDIO':
                return strings.AUDIO;
            case 'EXTERNAL':
                return strings.LINK;
            case 'VIDEO':
                return strings.VIDEO;
            default:
                return strings.ITEM;
        }
    };

    const renderIcon = (type: MediaType) => {
        switch (type) {
            case 'HTML':
                return 'description';
            case 'AUDIO':
                return 'mic_none';
            case 'EXTERNAL':
                return 'link';
            case 'VIDEO':
                return 'videocam';
            default:
                return '';
        }
    };

    const renderLanguage = (type: string | null) => {
        switch (type) {
            case 'pt':
                return strings.LANGUAGE_PT;
            case 'en':
                return strings.LANGUAGE_EN;
            default:
                return strings.LANGUAGE;
        }
    };

    return (
        <div className={`d-flex item-card-list ${error ? 'card-error' : ''}`}>
            <div className="img-container">
                <i
                    className="material-icons align-middle"
                    onClick={add ? () => handleAddToList(item) : () => handleRemoveFromList(item)}
                    onKeyDown={() => {}}
                    role="button"
                    tabIndex={0}
                >
                    {showButton && <>{add ? 'add_circle_outline' : 'cancel'}</>}
                </i>
                <img alt="" src={item.mainImage || imagePlaceholder} />
            </div>
            <div className="d-flex flex-column justify-content-center item-card-content">
                <span className="item-type">
                    <i className="material-icons-outlined align-middle">{renderIcon(item.mediaType)}</i>
                    {renderTitle(item.mediaType)}
                </span>
                <span className="item-title" title={item.name}>
                    {item.name}
                </span>
                <div>
                    <span className="item-info-key">{strings.LANGUAGE}: </span>
                    <span className="item-info-value">{renderLanguage(item.locale)}</span>
                    <span className="item-info-key">{strings.ESTIMATED_TIME}: </span>
                    <span className="item-info-value">{item.workload}</span>
                </div>
            </div>
            {error && (
                <div className="error-icon">
                    <i className="material-icons align-middle">error</i>
                </div>
            )}
        </div>
    );
};

export default ItemCard;
